
import React from "react";
import { Box, Heading, Text, VStack, List, ListItem, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  return (
    <Box maxW="1000px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 24, md: 32 }}>
      <VStack align="stretch" spacing={6}>
        <Link
          as="button"
          onClick={() => navigate("/apply")}
          aria-label="Back to Application"
          position="fixed"
          top={{ base: "84px", md: "96px" }}
          left={{ base: 4, md: 8 }}
          zIndex="sticky"
          bg="white"
          color="teal.600"
          fontWeight="semibold"
          border="1px solid"
          borderColor="teal.100"
          borderRadius="full"
          px={{ base: 0, sm: 4 }}
          py={{ base: 0, sm: 2 }}
          w={{ base: "42px", sm: "auto" }}
          h={{ base: "42px", sm: "auto" }}
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="sm"
          _hover={{ textDecoration: "none", bg: "teal.50" }}
        >
          <Text as="span" display={{ base: "inline", sm: "none" }}>←</Text>
          <Text as="span" display={{ base: "none", sm: "inline" }}>← Back</Text>
        </Link>
        <Heading size="lg" mt={16}>Privacy Policy</Heading>
        <Text color="gray.600">Effective Date: February 3, 2026</Text>

        <Heading as="h2" size="md" mt={4}>
          Privacy Policy
        </Heading>
        <Text>
          This privacy policy sets out how Swift Credit uses and protects any information that you give Swift Credit when you use this website.
        </Text>
        <Text>
          Swift Credit is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement.
        </Text>
        <Text>
          Swift Credit may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes. This policy is effective from February 3, 2026.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          What we collect
        </Heading>
        <Text>We may collect the following information:</Text>
        <List pl={6} styleType="disc" spacing={2}>
          <ListItem>
            Name, job title, employer, monthly income, social insurance number, birth date and other applicable information needed for personal identity verification.
          </ListItem>
          <ListItem>
            Contact information including a copy of drivers license, utility bill or any other applicable document that proves current residence.
          </ListItem>
          <ListItem>
            Demographic information such as location you reside in, including address, and postal codes.
          </ListItem>
          <ListItem>Other information relevant to customer receiving a loan.</ListItem>
        </List>

        <Heading as="h2" size="md" mt={4}>
          What we do with the information we gather
        </Heading>
        <Text>
          We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:
        </Text>
        <List pl={6} styleType="disc" spacing={2}>
          <ListItem>Internal record keeping.</ListItem>
          <ListItem>We may use the information to improve our products and services.</ListItem>
          <ListItem>
            If agreed to, we may periodically send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided.
          </ListItem>
          <ListItem>
            From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, fax or mail. We may use the information to customise the website according to your interests.
          </ListItem>
        </List>

        <Heading as="h2" size="md" mt={4}>
          Security
        </Heading>
        <Text>
          We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          How we use cookies
        </Heading>
        <Text>
          A cookie is a small file which asks permission to be placed on your computer’s hard drive. Once you agree, the file is added and the cookie helps analyse web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.
        </Text>
        <Text>
          We use traffic log cookies to identify which pages are being used. This helps us analyse data about webpage traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.
        </Text>
        <Text>
          Overall, cookies help us provide you with a better website by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.
        </Text>
        <Text>
          You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Links to other websites
        </Heading>
        <Text>
          Our website may contain links to other websites of interest. However, once you have used these links to leave our site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement. You should exercise caution and look at the privacy statement applicable to the website in question.
        </Text>

        <Heading as="h2" size="md" mt={4}>
          Controlling your personal information
        </Heading>
        <Text>
          We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.
        </Text>
        <Text>
          You may request details of personal information which we hold about you under the Data Protection Act 1998. If you would like a copy of the information held on you please write to: Email: support@swiftcredit.co
        </Text>
        <Text>Address: Swift Credit</Text>
        <Text>10060 Jasper Ave, Tower 1, Suite 2020</Text>
        <Text>Edmonton, AB T5J 3R8</Text>

        <Text>
          If you believe that any information we are holding on you is incorrect or incomplete, please write, phone or email us as soon as possible at the above address. We will promptly correct any information found to be incorrect.
        </Text>
      </VStack>
    </Box>
  );
}
